export { Media } from './Media';
export type { Props } from './Media.types';
